import React from 'react';
import { Search } from 'lucide-react';
import SectionsCard from '../interaction/SectionsCard';
import ColumnLabel from '../interaction/ColumnLabel';
import PillGroup from '../interaction/PillGroup';
import './UserFilters.css';

// Search wants the room; the pill groups size to their own content.
const COLUMN_WIDTHS = 'minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr)';

// Hardcoded, not generated: it keeps this section's collapsed state from
// colliding with any other SectionsCard in localStorage. See SectionsCard.
const PERSIST_ID = '76176867e8';

/**
 * The find/group controls at the top of /users, in the same SectionsCard the
 * rest of the page is built from.
 */
export default function UserFilters({
  searchQuery,
  setSearchQuery,
  groupBy,
  setGroupBy,
  groupByOptions,
  statusFilter,
  setStatusFilter,
  statusOptions,
}) {
  const searchColumn = (
    <div>
      <ColumnLabel icon={Search}>Search</ColumnLabel>
      <input
        className="uflt-input"
        type="search"
        placeholder="Email, name, company, or role…"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>
  );

  const groupByColumn = (
    <div>
      <ColumnLabel>Group by</ColumnLabel>
      <PillGroup
        options={groupByOptions}
        value={groupBy}
        onChange={setGroupBy}
        size="xs"
      />
    </div>
  );

  const statusColumn = (
    <div>
      <ColumnLabel>Status</ColumnLabel>
      <PillGroup
        options={statusOptions}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value || 'all')}
        size="xs"
      />
    </div>
  );

  return (
    <SectionsCard
      className="uflt"
      sections={[{
        key: 'find-users',
        title: 'Find users',
        collapsible: true,
        defaultOpen: true,
        persistId: PERSIST_ID,
        columnWidths: COLUMN_WIDTHS,
        columns: [searchColumn, groupByColumn, statusColumn],
      }]}
    />
  );
}
